const englishStrings = require("../i18n/locales/en.json");

/**
 * Function to return the english string if string id is not found for the locale
 * @param intl
 * @param stringId
 * @return {*}
 */
export const getLocalizedMessage = ({intl, stringId}) => {
    return intl.formatMessage({
        id: stringId,
        defaultMessage: englishStrings[stringId]
    })
};



// WEBPACK FOOTER //
// ./src/components/util/Localization.js